var $form = $('#contact-form')
var $submitArea = $form.find('.submit-area')
var $submit = $submitArea.find('a')
var $msg = $submitArea.find('.message')
$submit.click(function () {
	$.post('contact', $form.serialize())
	.done(function (data) {
		if (data.indexOf('good') !== -1) {
			$msg.append('<p>Your message has been sent successfully.</p>')
		}
		else {
			$msg.append('<p>There was an error sending your message!</p>')
		}
	})
	.fail(function (data) {
		$msg.append('<p>There was an error sending your message!</p>')
	})
	.always(function () {
		$submit.hide()
		$form.find('input').hide()
		$form.find('textarea').hide()
		$form.attr('style', '')
		$form.prev().remove()
		$form.prev().remove()
	})
})
